import { createAsyncThunk } from '@reduxjs/toolkit';
import notify from '../../utils/notify';

//Include Both Helper File with needed methods
import {
  getMailDetails as getMailDetailsApi,
  deleteMail as deleteMailApi,
} from '../../helpers/fakebackend_helper';

export const getMailDetails = createAsyncThunk(
  'mailbox/getMailDetails',
  async () => {
    try {
      const response = getMailDetailsApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const deleteMail = createAsyncThunk('mailbox/deleteMail', async mail => {
  try {
    const response = deleteMailApi(mail);
    notify.success('Mail deleted successfully.');
    return response;
  } catch (error) {
    notify.apiError(error, 'delete mail');
    return error;
  }
});
